import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const sanaLearn = defineConnector({
  identifier: "sanaLearn",
  name: "Sana Learn",
  tagLine: "AI-powered learning management platform",
  keywords: "lms courses training learners education",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ hostname }) => domainToRegex(hostname),
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Sana Learn API client",
      items: [
        {
          kind: "markdown",
          content:
            "In Sana Learn, go to **Manage → API**, add an API client, and copy its client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your Sana Learn details",
      items: [
        {
          kind: "hostname",
          label: "Sana Learn hostname",
          required: true,
          placeholder: "yourcompany.sana.ai",
          target: { kind: "configuration", field: "hostname" },
          helperText: "The hostname you use to access Sana Learn.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ hostname }) => `https://${hostname}/api/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => ["read", "write"],
    normalizeTokenRequest: (parameters) => {
      const scope = parameters.scope;
      return scope
        ? { ...parameters, scope: scope.replaceAll(" ", ",") }
        : parameters;
    },
    normalizeTokenResponse: (body) => {
      const data = body.data as Record<string, unknown> | null | undefined;
      return {
        ...body,
        access_token: data?.accessToken,
        token_type: data?.tokenType,
        expires_in: data?.expiresIn,
      };
    },
  },
  connectionTest: {
    protocol: "http",
    request: ({ hostname }) => `https://${hostname}/api/v0/users?limit=1`,
  },
  publicEnvVars: ({ hostname }) => ({
    SANA_LEARN_URL: hostname ? `https://${hostname}` : "",
  }),
});
